/**
 * Created by Rodrigo Quesada on 14/05/17.
 */

export class CapslockDetector {

    isCapslockOn(event: KeyboardEvent): boolean {
        const value = String.fromCharCode(event.which);
        return value.toUpperCase() === value && value.toLowerCase() !== value && !event.shiftKey;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/capslock/capslock-detector.class.ts